<template>
  <v-row>
    <v-col cols="12">
      <v-text-field
        v-model="result.name"
        label="ID"
        outlined
        dense
      ></v-text-field>
    </v-col>
    <v-col cols="12">
      <MdEditor v-model="result.text" language="en-US" noUploadImg/>
    </v-col>
  </v-row>
</template>

<script>
import { defineComponent } from 'vue'
import { MdEditor } from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'

export default defineComponent({
  name: 'MD',
  components: {
    MdEditor,
  },
  props: {
    baseValue: {
      type: Object,
      default: () => ({
        name: '',
        text: '',
      }),
    },
  },
  data() {
    return {
      result: { ...this.baseValue },
    }
  },
  emits: ['formAddEvent'],
  watch: {
    result: {
      handler() {
        this.sendDataToParent()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    sendDataToParent() {
      const dataToSend = {
        name: this.result.name,
        text: this.result.text,
      }
      this.$emit('formAddEvent', dataToSend)
    },
  },
})
</script>
